import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-0 ${
        scrolled ? 'bg-white/95 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'
      }`}
    >
      <div className="w-full px-6 lg:px-16 flex items-center justify-between">
        <Link to="/" className="cursor-pointer">
          <img
            src="https://static.readdy.ai/image/45f36db358624bab4161a57e418814dc/952de5dd7ee479a30999c64f6b1ab29c.png"
            alt="GO TALENTS"
            className="h-10 md:h-16 w-auto object-contain transition-all"
          />
        </Link>

        <div className="flex items-center gap-2 md:gap-3">
          <Link
            to="/hire-talent"
            className="px-3 py-2 md:px-6 md:py-2.5 text-[10px] md:text-xs font-semibold tracking-wider rounded-full transition-all cursor-pointer whitespace-nowrap bg-[#F49729] text-white hover:bg-[#e08820]"
          >
            <span className="inline md:hidden">HIRE</span>
            <span className="hidden md:inline">HIRE TALENT</span>
          </Link>

          <Link
            to="/apply-talent"
            className={`px-3 py-2 md:px-6 md:py-2.5 text-[10px] md:text-xs font-semibold tracking-wider rounded-full border transition-all cursor-pointer whitespace-nowrap ${
              scrolled
                ? 'border-gray-300 text-[#61616A] hover:border-[#F49729] hover:text-[#F49729]'
                : 'border-white/50 text-white hover:bg-white/10 hover:border-white'
            }`}
          >
            <span className="inline md:hidden">APPLY</span>
            <span className="hidden md:inline">APPLY AS TALENT</span>
          </Link>
        </div>
      </div>
    </header>
  );
}